import Unified from '@frontastic-engbers/lib/lib/utils/markdown';
export const CustomMarkdown = ({
  text
}) => <>{Unified.parse(text)}</>;